import {combineReducers} from 'redux';
import dashboardsReducer from './dashboards/reducer';
import tokensReducer from './token/reducer';


const rootReducers = combineReducers({
    dashboardsData : dashboardsReducer,
    tokensData : tokensReducer,
    // if there are other reducers , we can add here one by one
});
export default rootReducers;